import React, { useCallback, useState } from "react"
import { Grid } from "@material-ui/core"
import { Add as AddIcon } from "@material-ui/icons"
import { Button, Loading } from "letalkui"

import { PageHeader } from "@/components"

import useDidMount from "@/hooks/useDidMount"
import { ErrorType } from "@/hooks/useValidation"

import ErrorHandlerService from "@/services/ErrorHandler"
import RoleService, { RoleFormattedForList } from "@/services/RoleService"

import CreateRoleDialog from "@/pages/Admin/Role/RoleList/CreateRoleDialog"
import RoleListItem from "@/pages/Admin/Role/RoleList/RoleListItem"

import RoleListSkeleton from "@/skeletons/Admin/RoleListSkeleton"
import RoleGroupPermissionGate from "@/components/PermissionGate/RoleGroupPermissionGate"

const RoleList: React.FC = () => {
	const [roles, setRoles] = useState<RoleFormattedForList[]>([])
	const [loading, setLoading] = useState(true)

	const loadRoles = useCallback(async () => {
		setLoading(true)

		try {
			const data = await RoleService.retrieveAll()

			setRoles(data)
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)
		}

		setLoading(false)
	}, [])

	const handleDeleteRole = (roleId: number) => {
		setRoles(prev => prev.filter(role => role.id !== roleId))
	}

	useDidMount(() => {
		loadRoles()
	})

	return (
		<Grid container direction="column" spacing={8}>
			<Grid item xs={12}>
				<PageHeader
					title="Cargos"
					breadcrumb={{
						name: "Cargos",
						pathname: "/admin/attendance/roles"
					}}
					action={
						<RoleGroupPermissionGate action="create">
							<Button.Primary
								size="small"
								startIcon={<AddIcon />}
								onClick={() => CreateRoleDialog.open({})}
							>
								Adicionar Cargo
							</Button.Primary>
						</RoleGroupPermissionGate>
					}
				/>
			</Grid>

			<Grid item xs={12}>
				<Loading.FallbackProvidedSkeleton isLoading={loading} skeleton={<RoleListSkeleton />}>
					<Grid container spacing={2}>
						{roles?.map(role => (
							<Grid item xs={12} key={role.id}>
								<RoleListItem role={role} onDelete={() => handleDeleteRole(role.id)} />
							</Grid>
						))}
					</Grid>
				</Loading.FallbackProvidedSkeleton>
			</Grid>
		</Grid>
	)
}

export default RoleList
